import { SelectedBinListInBinGroup } from "../../redux/BinGroup/state";


export function ValidateEmail(input:string) {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (input.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }


export function isGovernemnt(user_id:number){
  // 4 is government 
  return user_id === 4
}

export function isSuperAdmin(user_id:number){
  return user_id ===7
}

export function checkForDuplicateBinSequence(arr:SelectedBinListInBinGroup[]) {
    const seen = new Set();
    const duplicates = [];
    for (const obj of arr) {
        if (seen.has(obj.bin_group_sequence?.toString())) {
            duplicates.push(obj.bin_group_sequence?.toString());
        } else {
            seen.add(obj.bin_group_sequence?.toString());
        }
    }

    return duplicates;
}

export function checkBinSequenceLimit(binList: any[], totalToilets: number) {
  const invalidSequences = binList.filter(bin => parseInt(bin.bin_group_sequence) > totalToilets)
  if (invalidSequences.length > 0) {
    const invalidSeqNumbers = invalidSequences.map(bin => bin.bin_group_sequence).join(', ')
    return `次序 ${invalidSeqNumbers} 不能大於總廁所數量 ${totalToilets}`
  }
  return null
}
